export const QuotationResources = {
    es: {
        ['thanks_for_rent']: 'Gracias por tu renta',
        ['go_get_your_car']: 'Ve por tu auto',
        ['extra_type_daily']: 'Diario',
        ['extra_type_one time']: 'Una Vez',
        ['reservation']: 'Reservación',
        ['your_rental']: 'Tu renta',
        ['pickup']: 'Recogida',
        ['dropoff']: 'Entrega',
        ['rental_days']: 'Días de renta',
        ['cost_per_day']: 'Costo por día',
        ['total_cost']: 'Costo total',
        ['upgrade_reservation']: 'Mejora tu reserva',
        ['per_day']: "<p>Por</p><p>Día</p>",
        ['passengers']: 'Pasajeros',
        ['suitcases']: 'Maletas',
        ['yes']: 'Sí',
        ['to']: 'al',
        ['select']: 'Seleccionar',
        ['deselect']: 'Deseleccionar',
        ['additional']: 'Adicionales',
        ['discount']: 'Descuento {{discount}}'
    },
    en: {
        ['thanks_for_rent']: 'Thanks for your rent',
        ['go_get_your_car']: 'Go get your car',
        ['extra_type_daily']: 'Daily',
        ['extra_type_one time']: 'One Time',
        ['reservation']: 'Reservation',
        ['your_rental']: 'Your rental',
        ['pickup']: 'Pick-up',
        ['dropoff']: 'Drop-off',
        ['rental_days']: 'Rental days',
        ['cost_per_day']: 'Cost per day',
        ['total_cost']: 'Total cost',
        ['upgrade_reservation']: 'Upgrade your reservation',
        ['per_day']: "<p>Per</p><p>Day</p>",
        ['passengers']: 'Passengers',
        ['suitcases']: 'Suitcases',
        ['yes']: 'Yes',
        ['to']: 'to',
        ['select']: 'Select',
        ['deselect']: 'Deselect',
        ['additional']: 'Additional',
        ['discount']: '{{discount}} Discount'
    }
}
